import React, { useEffect, useMemo } from 'react';
import { DecoupledEditor } from 'ckeditor5';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import styles from './Editor.module.css';
import { useToolbarManager } from '../shared/CKEditor/util/ToolbarManager';
import { getCKEditorConfig } from '../shared/CKEditor/config/EditorConfig';
import { useCurrentUser } from '@qualio/ui-components';
import { createEditorReadyHandler } from './editorReadyHandler';

type EditorProps = {
  onChange: (data: string) => void;
  index: number;
  value?: string;
  'data-cy'?: string;
};

export const Editor: React.FC<EditorProps> = ({ onChange, index, value, ...rest }) => {
  const { companyId } = useCurrentUser();

  const editorConfig = useMemo(
    () => ({
      ...getCKEditorConfig(companyId),
    }),
    [companyId],
  );
  const toolbarManager = useToolbarManager();
  const pageHeaderSectionIndex = `pageHeaderSection${index}`;

  useEffect(() => () => toolbarManager.teardownIndexedStickyToolbar(), [toolbarManager]);

  return (
    <>
      <div className={styles['sections-editor__heading-section']} id={pageHeaderSectionIndex} />
      <div
        data-cy={rest['data-cy'] ?? 'editor-view'}
        id="sectionEditorContent"
        className={`${styles['sections-editor__document__section-content']} document`}
      >
        <CKEditor
          onReady={createEditorReadyHandler(toolbarManager, pageHeaderSectionIndex)}
          onChange={(event: any, editor: DecoupledEditor) => {
            onChange(editor.getData());
          }}
          editor={DecoupledEditor}
          watchdogConfig={{ saveInterval: 30000 }}
          data={value}
          config={editorConfig}
        />
      </div>
    </>
  );
};
